import React, { useState, useRef, useCallback, useEffect } from 'react';
import { debounce } from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';

import { sanitiseUrlParam } from 'utils';

import SearchIcon from 'icons/search.svg';
import styles from './MiniSearch.module.scss';

interface MiniSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export const MiniSearch: React.FC<MiniSearchProps> = ({ value, onChange }) => {
  const [displayedValue, setDisplayedValue] = useState(value);
  const displayedValueRef = useRef(displayedValue);
  displayedValueRef.current = displayedValue;

  const { search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => setDisplayedValue(value), [value]);

  useEffect(() => {
    if (search) {
      const searchTerms = search.replace('?', '').split('&');

      let searchTerm = '';

      searchTerms.forEach((term: string) => {
        const [key, value] = term.split('=');

        if (key === 'searchTerm') {
          searchTerm = sanitiseUrlParam(value);
        }
      });

      if (searchTerm) {
        setDisplayedValue(searchTerm);
        onChange(searchTerm);

        navigate(window.location.pathname);
      }
    }
  }, [search, navigate, onChange]);

  const handleOnChange = useRef(debounce(onChange, 50));

  const sendEvent = useCallback(() => {
    // future amplitude tracking fo search event
  }, []);

  const handleSendEvent = useRef(debounce(sendEvent, 1000));

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>): void => {
      const { value } = e.target;

      setDisplayedValue(value);
      handleOnChange.current(value);

      handleSendEvent.current();
    },
    [handleOnChange]
  );
  return (
    <form className={`${styles.Outer}`} role="search" onSubmit={(event) => event.preventDefault()}>
      <input
        type="text"
        placeholder="Search..."
        onChange={handleChange}
        value={displayedValue}
        data-testid="search-input"
        className="amp-unmask"
      />
      <img src={SearchIcon} alt="" />
    </form>
  );
};
